import { render, staticRenderFns } from "./PopupDownload.vue?vue&type=template&id=4e6d94a2"
import script from "./PopupDownload.vue?vue&type=script&lang=js"
export * from "./PopupDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports